module.exports = __webpack_public_path__ + "static/media/kennon-thumbnailMOBILE.acf886a0.jpg";